import {
  Invoice, InvoiceStatusDetails, InvoicePostSplit,
  InvoiceDetail, ExistingInvoiceResponse, UniqueInvoiceKey,
  InvoiceAttachment
} from "../models/Invoice";
import { InvoiceChange } from "../models/InvoiceChanges";
import { PaymentRequestResult } from "../models/PaymentRequest";
import { SharePointProcessFileResult } from "../models/SharePoint";
import {
  deleteRequest, getRequest, host,
  patchRequest, postRequest, putRequest, RunAllResponse
} from "./apiService";

const invoiceApi = `${host}/api/invoice`;
const paymentRequestApi = `${host}/api/PaymentRequest`;

export async function getInvoices(fromDate: string, toDate: string) {
  return getRequest<Invoice[]>(
    `${invoiceApi}?fromDate=${fromDate}&toDate=${toDate}`
  );
}

export async function getInvoice(invoiceId: string) {
  return getRequest<Invoice>(
    `${invoiceApi}/${invoiceId}`
  );
}

export async function getStatusHistory(id: string) {
  return getRequest<InvoiceStatusDetails[]>(
    `${invoiceApi}/gethistory/${id}`
  );
}

export async function getInvoicePaymentRequests(invoiceId: string) {
  return getRequest<PaymentRequestResult[]>(
    `${invoiceApi}/${encodeURIComponent(invoiceId)}/payment-requests`
  );
}

export async function addInvoice(invoice: Invoice) {
  delete (invoice as Partial<Invoice>).id;
  if (invoice.attachment) {
    delete (invoice.attachment as Partial<InvoiceAttachment>).id;
    delete (invoice.attachment as Partial<InvoiceAttachment>).invoiceId;
  }

  invoice.invoiceDetails?.forEach(detail => {
    delete (detail as Partial<InvoiceDetail>).id;
    delete (detail as Partial<InvoiceDetail>).invoiceId;
  });

  return postRequest<Invoice | undefined>(
    `${invoiceApi}`, invoice
  );
}

export async function updateInvoice(invoice: Invoice) {
  return putRequest<Invoice | undefined>(
    `${invoiceApi}/${invoice.id}`, invoice
  );
}

export async function updateStatus(details: InvoiceStatusDetails) {
  return patchRequest<Invoice | undefined>(
    `${invoiceApi}/setStatus`, details
  );
}

export async function emailChangesToAuthor(changes: InvoiceChange) {
  return postRequest<InvoiceChange>(
    `${invoiceApi}/sendChanges`, changes
  );
}

export async function deleteInvoice(id: string) {
  return deleteRequest(`${invoiceApi}/${id}`);
}

export async function getSplitInvoices(fromDate: string, toDate: string) {
  return getRequest<InvoicePostSplit[]>(
    `${invoiceApi}/postsplit?fromDate=${fromDate}&toDate=${toDate}`
  );
}

export async function processInvoices(invoiceId?: string) {
  const queryString = invoiceId ? `?invoiceId=${encodeURIComponent(invoiceId)}` : "";
  return postRequest<RunAllResponse>(`${paymentRequestApi}/runAll${queryString}`);
}

export async function checkExistingInvoices(keys: UniqueInvoiceKey[]) {
  return postRequest<ExistingInvoiceResponse[]>(`${invoiceApi}/check-existing`, keys);
}

export async function attachFileToInvoice(invoiceId: string, fileId: string) {
  return patchRequest<SharePointProcessFileResult>(`${invoiceApi}/${invoiceId}/add-attachment`, { fileId });
}
export async function findAttachFileByName(fileName: string) {
  const params = new URLSearchParams({ name: fileName });
  return getRequest<SharePointProcessFileResult>(`${host}/api/SharePoint/find-by-name?${params.toString()}`);
}

export async function moveFile(invoiceId: string) {
  return getRequest<InvoiceAttachment>(`${invoiceApi}/${invoiceId}/move-attachment`);
}
